export const ALL_LANGUAGES = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Russian',
  'Chinese (Mandarin)',
  'Chinese (Cantonese)',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Bengali',
  'Urdu',
  'Turkish',
  'Dutch',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Polish',
  'Czech',
  'Hungarian',
  'Romanian',
  'Bulgarian',
  'Greek',
  'Hebrew',
  'Thai',
  'Vietnamese',
  'Indonesian',
  'Malay',
  'Filipino',
  'Swahili',
  'Amharic',
  'Yoruba',
  'Zulu',
  'Afrikaans',
  'Catalan',
  'Basque',
  'Galician',
  'Welsh',
  'Irish',
  'Scottish Gaelic',
  'Icelandic',
  'Faroese',
  'Estonian',
  'Latvian',
  'Lithuanian',
  'Slovak',
  'Slovenian',
  'Croatian',
  'Serbian',
  'Bosnian',
  'Macedonian',
  'Albanian',
  'Maltese',
  'Georgian',
  'Armenian',
  'Azerbaijani',
  'Kazakh',
  'Uzbek',
  'Kyrgyz',
  'Tajik',
  'Turkmen',
  'Mongolian',
  'Tibetan',
  'Nepali',
  'Sinhala',
  'Tamil',
  'Telugu',
  'Kannada',
  'Malayalam',
  'Marathi',
  'Gujarati',
  'Punjabi',
  'Odia',
  'Assamese',
  'Kashmiri',
  'Sindhi',
  'Konkani',
  'Manipuri',
  'Khasi',
  'Mizo',
  'Bodo',
  'Sanskrit',
  'Pali',
  'Persian',
  'Kurdish',
  'Pashto',
  'Dari',
  'Balochi',
  'Luxembourgish',
  'Romansh',
  'Frisian',
  'Breton',
  'Cornish',
  'Manx',
  'Faroese',
  'Greenlandic',
  'Sami',
  'Karelian',
  'Veps',
  'Livonian',
  'Votic',
  'Ingrian',
  'Võro',
  'Seto',
  'Livvi',
  'Ludic',
  'Kven',
  'Meänkieli',
  'Tornedalen Finnish',
  'Kven',
  'Meänkieli',
  'Tornedalen Finnish',
]; 